import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

import stylesAutoLayout from '../AutoLayout.less';
import styles from './StaticText.less';
import AutoLayoutService from 'src/js/lib/auto_layout/auto_layout_service';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';
import {KEYWORD_PROP_CONTENT_VALUE} from 'src/js/model/auto_layout_screen_data_helpers';

const StaticText = ({data, idSuffix, inputName, screenId}) => (
  <span
    name={inputName}
    id={AutoLayoutService.getComponentId(screenId, inputName, idSuffix)}
    className={classNames(
      styles.dlStaticTextInput,
      stylesAutoLayout.dlScreenComponentInput
    )}
    title={data[KEYWORD_PROP_CONTENT_VALUE] || ''}
  >
    {data[KEYWORD_PROP_CONTENT_VALUE] || ''}
  </span>
);

StaticText.displayName = 'StaticText';

/* eslint-disable react/no-unused-prop-types */
StaticText.propTypes = {
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  isReadOnly: PropTypes.bool,
  isTextOnly: PropTypes.bool,
  inputName: PropTypes.string,
  label: PropTypes.string,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
};

StaticText.defaultProps = {
  data: {},
  idSuffix: '',
  pathToData: '',
  isReadOnly: false,
  isTextOnly: false,
  inputName: '',
  label: '',
  expanded: false,
};

export default StaticText;
